import { Component, Inject, ViewChild, ElementRef } from '@angular/core';
import { AdminService } from './admin.service';
import { Restangular } from 'ngx-restangular';
import { environment } from '@env/environment';
import { Router, ActivatedRoute } from '@angular/router';
import { RequestOptions, Http, Headers } from '@angular/http';
import { map } from 'rxjs/operators';
import { CoreService } from '../core/core.service';
import { Main } from '@app/core/main.service';

@Component({
  selector: 'cp-useradd',
  templateUrl: './useradd.component.html',
})

export class UserAddComponent {

  user: any;
  file: any;
  topPart: string;
  bottomPart: string;
  secondContent: string;
  clients: any;
  formHasError: boolean;
  match: boolean;
  isLoading: boolean;
  id: string;
  branches: any = [];

  constructor(private api: AdminService, private route: ActivatedRoute, private mainService: Main, private http: Http, private router: Router,
    @Inject(Restangular) public Restangular) {
    // this.difference =  +(new Date())-  +(new Date('2018/08/01 14:00:00'));

    this.user = {
      username: '',
      email: '',
      password: '',
      type: '',
      status: '',
      client_id: '',
      verified: false,
      branch_id: null
    };
    this.clients = [];
    //padding:20px 200px 20px 200px;
    this.formHasError = false;
    this.match = true;
    this.isLoading = false;

    if (this.route.queryParams['value']['id']) {
      debugger;
      this.id = this.route.queryParams['value']['id'];
      this.getUser();
    }
    this.getBranches();
  }

  fileChange(event): void {
    const fileList: FileList = event.target.files;
    if (fileList.length > 0) {
      this.file = fileList[0];
    }
  }


  getBranches() {
    var filter = '?all=true';
    this.api.getBranches(filter).subscribe((resp: any) => {
      debugger;
      this.branches = resp.data;
      this.branches.forEach(element => {
        element.text = element.name + ' - ' + element.city;
      });
    }, (err: any) => {
      debugger;
      this.mainService.toast({ title: 'Error', body: err.data, type: 'danger' });
    });
  }

  getUser() {
    debugger;
    this.api.getUser(this.id).subscribe((res: any) => {
      debugger;
      this.user = res.data;
      //this.userForm.setValue(res.data);
    });
  }

  uploadFile(id: any) {
    const formData = new FormData();
    formData.append('file', this.file, this.file.name);
    var url = environment.production
      ? environment.ONLINE_BASE_URL :
      environment.LOCAL_BASE_URL;
    const headers = new Headers();
    headers.append('Authorization', 'Bearer ' + localStorage.getItem('access_token'));
    const options = new RequestOptions({ headers: headers });
    this.http.post(url + 'file/users/' + id, formData, options)
      .pipe(map(res => res.json()))
      /* .catch(error => Observable.throw(error)) */
      .subscribe(data => console.log(data),
        error => console.log(error)
      );
    this.router.navigate(['/users']);
  }

  @ViewChild('userForm', { read: ElementRef }) tref: ElementRef;

  checkFormValidity(): boolean {
    return (this.tref.nativeElement.className.indexOf('ng-invalid') !== -1);
  }

  confirmPassword() {
    this.match = this.user.password === this.user.password_confirmation;
  }

  addUser(id: any = null) {
    debugger;
    this.isLoading = !this.isLoading;
    let isInvalid = this.checkFormValidity();
    this.match = this.user.password === this.user.password_confirmation;
    if (!isInvalid && this.match) {
      /* this.user.firstContent = this.topPart + ' ' + this.user.first_name + ' ' + this.bottomPart;
      this.user.secondContent = this.secondContent; */
      this.api.addUser(id, this.user).subscribe((res: any) => {
        debugger;
        //this.api.addUser(id, { user: this.user }).subscribe((res: any) => {
        this.isLoading = !this.isLoading;
        if (this.file) {
          this.uploadFile(res.data.id);
        } else {
          //this.mainService.addToast('Success', 'User successfully added!');
          this.router.navigate(['/users']);
        }
      }, (err) => {
        err = err;
        this.isLoading = !this.isLoading;
        //this.mainService.addToast('Error', 'Could not add user!');
      });
    } else {
      this.isLoading = !this.isLoading;
      this.formHasError = true;
    }

  }

}
